import SetPassword from "pages/Onboarding/SetPassword";
import { Navigate, Route, Routes } from "react-router-dom";

export function PasswordRoutes() {
  return (
    <Routes>
      <Route path="/set_password" element={<SetPassword />} />
      <Route path="/set_password/:slug" element={<SetPassword />} />
      <Route path="*" element={<Navigate to="/set_password" />} />
    </Routes>
  );
}
